/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Today_FilterInputs */

const en_today_filter = /** @type {(inputs: Today_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Today`)
};

const nl_today_filter = /** @type {(inputs: Today_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vandaag`)
};

/**
* | output |
* | --- |
* | "Today" |
*
* @param {Today_FilterInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const today_filter = /** @type {((inputs?: Today_FilterInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Today_FilterInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_today_filter(inputs)
	return en_today_filter(inputs)
});